/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { GET_CALENDAR_EVENTS, GET_PROJECTED_SENDS, HAS_CALENDAR_ACCESS } from '../constants';

import { createMcGetAction, createMcHasAccessAction } from '../api';

export function getCalendarEvents({ data = {}, startDate = new Date(), endDate = new Date(), ...rest } = {}) {
  const options = {
    data,
    ...rest,
  };

  options.data.starttime = `${startDate.getMonth() + 1}-${startDate.getDate()}-${startDate.getFullYear()}`;
  options.data.endtime = `${endDate.getMonth() + 1}-${endDate.getDate()}-${endDate.getFullYear()} 23:59:59`;

  return createMcGetAction(GET_CALENDAR_EVENTS, 'platform-internal/v1/calendar/events?$pageSize=500&$page=1', options);
}

export function getProjectedSends({
  data = {},
  startDate = new Date(),
  endDate = new Date(),
  page = 1,
  pageSize = 50,
  ...rest
} = {}) {
  const options = {
    data,
    ...rest,
  };

  options.data.starttime = `${startDate.getMonth() + 1}-${startDate.getDate()}-${startDate.getFullYear()}`;
  options.data.endtime = `${endDate.getMonth() + 1}-${endDate.getDate()}-${endDate.getFullYear()} 23:59:59`;

  return createMcGetAction(
    GET_PROJECTED_SENDS,
    `platform-internal/v1/calendar-projectedevents?$pageSize=${pageSize}&$page=${page}`,
    options
  );
}

export function hasCalendarAccess() {
  return createMcHasAccessAction(HAS_CALENDAR_ACCESS, 'Calendar');
}
